import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { userInfoBackend } from './user-info.backend';
import { userInfoReducer } from './user-info.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('userInfo', userInfoReducer),
    BackendModule.forFeature('userInfo', userInfoBackend),
  ],
})
export class DatastoreUserInfoModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-info/user-info.module.ts